/* Crest – tiroir panier (gauche) + compte à rebours de réservation 10 min */
(function () {
  if (window.__crestCartDrawer) return;
  window.__crestCartDrawer = true;

  var SECTION = 'crest-cart-drawer';
  var KEY = 'crest_cart_reservation_end';
  var DURATION = 10 * 60 * 1000;
  var memoryEnd = null;
  var intervalId = null;

  /* ---------- Compte à rebours ---------- */
  function getEnd() {
    try {
      var v = window.localStorage.getItem(KEY);
      return v ? parseInt(v, 10) : null;
    } catch (e) {
      return memoryEnd;
    }
  }

  function setEnd(value) {
    memoryEnd = value;
    try {
      if (value) window.localStorage.setItem(KEY, String(value));
      else window.localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function restartTimer() {
    setEnd(Date.now() + DURATION);
    updateTimers();
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function updateTimers() {
    document.querySelectorAll('cart-reservation-timer').forEach(function (el) {
      if (el.update) el.update();
    });
  }

  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      var count = parseInt(this.dataset.itemCount || '0', 10);
      if (count <= 0) {
        setEnd(null);
        this.hidden = true;
        return;
      }
      if (!getEnd()) setEnd(Date.now() + DURATION);
      this.hidden = false;
      this.update();
      if (!intervalId) intervalId = window.setInterval(updateTimers, 1000);
    }

    update() {
      if (this.hidden) return;
      var end = getEnd();
      if (!end) return;
      var left = Math.max(0, end - Date.now());
      var timeEl = this.querySelector('[data-timer-time]');
      var bar = this.querySelector('[data-timer-bar]');
      if (left > 0) {
        var s = Math.ceil(left / 1000);
        if (timeEl) timeEl.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
        if (bar) bar.style.transform = 'scaleX(' + (left / DURATION).toFixed(4) + ')';
        this.classList.remove('is-expired');
        this.classList.toggle('is-urgent', left <= 60000);
      } else {
        if (timeEl) timeEl.textContent = '00:00';
        if (bar) bar.style.transform = 'scaleX(0)';
        this.classList.remove('is-urgent');
        this.classList.add('is-expired');
      }
    }
  }

  if (!customElements.get('cart-reservation-timer')) {
    customElements.define('cart-reservation-timer', CartReservationTimer);
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) updateTimers();
  });

  /* ---------- Tiroir panier ---------- */
  function routes() {
    return window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  }

  function getDrawer() {
    return document.querySelector('crest-cart-drawer');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cr-cart').forEach(function (a) {
      a.textContent = a.textContent.replace(/\[\d+\]/, '[' + count + ']');
    });
  }

  function parseJSON(res) {
    return res.json().then(function (j) {
      return { ok: res.ok, data: j };
    });
  }

  class CrestCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', (function (e) {
        if (e.key === 'Escape') this.close();
      }).bind(this));
    }

    onClick(e) {
      if (e.target.closest('[data-ccd-close]')) {
        e.preventDefault();
        this.close();
        return;
      }
      var q = e.target.closest('[data-ccd-qty]');
      if (q) {
        e.preventDefault();
        var line = q.closest('[data-key]');
        if (line) this.change(line.dataset.key, parseInt(q.dataset.ccdQty, 10), line);
      }
    }

    open(trigger) {
      this._trigger = trigger || document.activeElement;
      this.classList.add('is-open');
      this.removeAttribute('aria-hidden');
      document.documentElement.classList.add('ccd-lock');
      var panel = this.querySelector('.ccd-panel');
      window.setTimeout(function () {
        if (panel) panel.focus({ preventScroll: true });
      }, 60);
      updateTimers();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ccd-lock');
      if (this._trigger && this._trigger.focus) this._trigger.focus({ preventScroll: true });
    }

    render(html) {
      if (!html) return this.refresh();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('crest-cart-drawer');
      var newBody = doc.querySelector('[data-ccd-body]');
      var body = this.querySelector('[data-ccd-body]');
      if (newBody && body) body.innerHTML = newBody.innerHTML;
      var newCount = doc.querySelector('[data-ccd-count]');
      var countEl = this.querySelector('[data-ccd-count]');
      if (newCount && countEl) countEl.textContent = newCount.textContent;
      var count = fresh ? parseInt(fresh.dataset.count || '0', 10) : 0;
      this.dataset.count = count;
      updateHeaderCount(count);
    }

    refresh() {
      var self = this;
      return fetch(window.location.pathname + '?sections=' + SECTION)
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j[SECTION]) self.render(j[SECTION]); })
        .catch(function () {});
    }

    change(key, quantity, line) {
      var self = this;
      if (line) line.classList.add('is-busy');
      fetch(routes().cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, quantity || 0),
          sections: [SECTION],
          sections_url: window.location.pathname
        })
      })
        .then(parseJSON)
        .then(function (res) {
          if (!res.ok || res.data.status || res.data.errors) {
            self.showError(res.data.description || res.data.errors || res.data.message);
            return self.refresh();
          }
          self.render(res.data.sections && res.data.sections[SECTION]);
        })
        .catch(function () {
          if (line) line.classList.remove('is-busy');
          self.showError();
        });
    }

    showError(message) {
      var box = this.querySelector('[data-ccd-error]');
      if (!box) return;
      box.textContent = typeof message === 'string' && message ? message : this.dataset.errorText || '';
      box.hidden = false;
      window.clearTimeout(this._errTimer);
      this._errTimer = window.setTimeout(function () { box.hidden = true; }, 5000);
    }
  }

  if (!customElements.get('crest-cart-drawer')) {
    customElements.define('crest-cart-drawer', CrestCartDrawer);
  }

  function drawerUsable() {
    var d = getDrawer();
    return d && d.dataset.cartPage !== 'true' ? d : null;
  }

  function clearFormError(form) {
    var old = form.querySelector('.ccd-form-error');
    if (old) old.remove();
  }

  function showFormError(form, message) {
    clearFormError(form);
    var p = document.createElement('p');
    p.className = 'ccd-form-error';
    p.setAttribute('role', 'alert');
    p.textContent = message;
    form.appendChild(p);
  }

  /* Ajout au panier : on intercepte tous les formulaires produit */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action) || form.hasAttribute('data-ccd-ignore')) return;
    var drawer = drawerUsable();
    if (!drawer) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var fd;
    try { fd = new FormData(form, e.submitter); } catch (err) { fd = new FormData(form); }
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);

    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    }
    clearFormError(form);

    fetch(routes().cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(parseJSON)
      .then(function (res) {
        if (!res.ok || res.data.status) {
          showFormError(form, res.data.description || res.data.message || drawer.dataset.errorText);
          return;
        }
        restartTimer();
        drawer.render(res.data.sections && res.data.sections[SECTION]);
        drawer.open(btn);
      })
      .catch(function () {
        showFormError(form, drawer.dataset.errorText);
      })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        }
      });
  }, true);

  /* Lien « Panier [n] » du header : ouvre le tiroir */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.cr-cart, [data-ccd-open]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var drawer = drawerUsable();
    if (!drawer) return;
    e.preventDefault();
    drawer.open(link);
    drawer.refresh();
  });

  /* Retour arrière (cache navigateur) : remet le panier à jour */
  window.addEventListener('pageshow', function (e) {
    var d = getDrawer();
    if (e.persisted && d) d.refresh();
  });
})();
